class Console {
  private static instance: Console;
  private constructor() {}
  public static getInstance(): Console {
    if (!Console.instance) Console.instance = new Console();
    return Console.instance;
  }

  private hasDebug(): boolean {
    try {
      let urlParams = new URLSearchParams(window.location.search);
      return urlParams.has('debug');
    } catch (err) {
      console.error(err);
    }
    return false;
  }

  public log(content: any) {
    if (this.hasDebug()) console.log(content);
  }
  public warn(content: any) {
    if (this.hasDebug()) console.warn(content);
  }
  public error(content: any) {
    if (this.hasDebug()) console.error(content);
  }
}

export default Console.getInstance();
